<select #selectInput class="ui fluid dropdown" (change)="onValueChanged($event)" [disabled]="_isDisable">
    <option *ngFor="let i of items" value="{{i.id}}">{{i.value}}</option>
</select>

<!-- [disabled]="disabledItem(i.id)" -->